var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "primary",
      attrs: { "mobile-breakpoint": "1380", width: "250", dark: "", app: "" },
      model: {
        value: _vm.drawer,
        callback: function($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer"
      }
    },
    [
      _c(
        "v-list-item",
        {
          staticClass: "primary",
          class: _vm.miniVariant ? "mini-variant-logo" : ""
        },
        [
          !_vm.miniVariant
            ? _c("v-list-item-avatar", { attrs: { size: "47" } }, [
                _c("img", {
                  attrs: { src: "/static/cl-light.svg", alt: "LOGO" }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.miniVariant
            ? _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.applicationName) +
                        "\n            "
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-list",
        {
          key: _vm.refresh,
          staticClass: "primary",
          attrs: { dense: "", subheader: "" }
        },
        [
          _vm._l(_vm.menu, function(menuItem, index) {
            return menuItem.restriction == "none" ||
              _vm.hasPermission(menuItem.restriction)
              ? [
                  typeof menuItem.children == "undefined"
                    ? [
                        _vm.miniVariant
                          ? [
                              _c(
                                "v-tooltip",
                                {
                                  key:
                                    "minivariant-collapse-single-" +
                                    index +
                                    "-" +
                                    _vm.key,
                                  attrs: { right: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-list-item",
                                              _vm._g(
                                                {
                                                  class: _vm.activeMenuItem(
                                                    menuItem
                                                  )
                                                    ? "accent--text v-list-item--active"
                                                    : "",
                                                  attrs: { exact: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.menuItemClick(
                                                        menuItem
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        _vm._s(menuItem.icon)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(menuItem.name)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(menuItem.name) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              )
                            ]
                          : [
                              !menuItem.restriction ||
                              menuItem.restriction == "none" ||
                              _vm.hasPermission(menuItem.restriction)
                                ? _c(
                                    "v-list-item",
                                    {
                                      key:
                                        "non-minivariant-collapse-single-" +
                                        index +
                                        "-" +
                                        _vm.key,
                                      class: _vm.activeMenuItem(menuItem)
                                        ? "accent--text v-list-item--active"
                                        : "",
                                      attrs: { exact: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.menuItemClick(menuItem)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(menuItem.icon))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(menuItem.name))
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                      ]
                    : typeof menuItem.collapsible !== "undefined" &&
                      menuItem.collapsible
                    ? [
                        _vm.miniVariant
                          ? _vm._l(menuItem.children, function(
                              menuChild,
                              childIndex
                            ) {
                              return _c(
                                "v-tooltip",
                                {
                                  key:
                                    "minivariant-collapse-" +
                                    childIndex +
                                    "-" +
                                    index +
                                    "-" +
                                    _vm.key,
                                  attrs: { right: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-list-item",
                                              _vm._g(
                                                {
                                                  class: _vm.activeMenuItem(
                                                    menuChild
                                                  )
                                                    ? "accent--text v-list-item--active"
                                                    : "",
                                                  attrs: { exact: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.menuItemClick(
                                                        menuChild
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        _vm._s(menuChild.icon)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(menuChild.name)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  typeof menuChild.miniName !== "undefined"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(menuItem.heading) +
                                            " - " +
                                            _vm._s(menuChild.miniName) +
                                            "\n                        "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(menuItem.heading) +
                                            " - " +
                                            _vm._s(menuChild.name) +
                                            "\n                        "
                                        )
                                      ])
                                ]
                              )
                            })
                          : [
                              _c(
                                "v-list-group",
                                {
                                  attrs: { value: _vm.mustOpen(menuItem) },
                                  on: {
                                    click: function($event) {
                                      return _vm.setActiveExpansionPanel(
                                        menuItem.heading
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-list-item",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      menuItem.heading.toUpperCase()
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(menuItem.children, function(
                                    menuChild,
                                    childIndex
                                  ) {
                                    return !menuChild.restriction ||
                                      menuChild.restriction == "none" ||
                                      _vm.hasPermission(menuChild.restriction)
                                      ? _c(
                                          "v-list-item",
                                          {
                                            key:
                                              "non-minivariant-collapse-" +
                                              childIndex +
                                              "-" +
                                              _vm.key,
                                            class: _vm.activeMenuItem(menuChild)
                                              ? "accent--text v-list-item--active"
                                              : "",
                                            attrs: { exact: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.menuItemClick(
                                                  menuChild
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c("v-icon", [
                                                  _vm._v(_vm._s(menuChild.icon))
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(_vm._s(menuChild.name))
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ]
                      ]
                    : [
                        !_vm.miniVariant
                          ? _c(
                              "v-list-item",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(menuItem.heading.toUpperCase()))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(menuItem.children, function(
                          menuChild,
                          childIndex
                        ) {
                          return !menuChild.restriction ||
                            menuChild.restriction == "none" ||
                            _vm.hasPermission(menuChild.restriction)
                            ? _c(
                                "v-tooltip",
                                {
                                  key:
                                    "collapse-" +
                                    index +
                                    "-" +
                                    childIndex +
                                    "-" +
                                    _vm.key,
                                  attrs: {
                                    right: "",
                                    disabled: !_vm.miniVariant
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-list-item",
                                              _vm._g(
                                                {
                                                  class: _vm.activeMenuItem(
                                                    menuChild
                                                  )
                                                    ? "accent--text v-list-item--active"
                                                    : "",
                                                  attrs: { exact: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.menuItemClick(
                                                        menuChild
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        _vm._s(menuChild.icon)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(menuChild.name)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm.miniVariant &&
                                  typeof menuChild.miniName !== "undefined"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(menuChild.miniName) +
                                            "\n                    "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(menuChild.name) +
                                            "\n                    "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                  _vm._v(" "),
                  _c("v-divider")
                ]
              : _vm._e()
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }